'use strict';
import {module} from '../app';

module.directive('textarea', function () {
    return {
        restrict: 'E',

        scope: {
        },
        link: function (scope, element, attrs) {
            element.bind('touchend  touchmove touchstart', function(e){
                e.stopPropagation();
            });
        }
    };
});


// WEBPACK FOOTER //
// ./src/scripts/directives/textareaScroll.js